import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { RankService } from '@rank/infra';
import { GetUsersTopRankResponse, UserRankDto } from '@core-http';
import { GetTopRankQueryResult, TopRankUser } from './get-top-rank.query-result';

export class GetTopRankQueryHandler {
  private readonly rankService: RankService = inject(RankService);

  getTopRank(): Observable<GetTopRankQueryResult> {
    return this.rankService.getTop50().pipe(map((dto: GetUsersTopRankResponse) => this.mapToQueryResult(dto)));
  }

  private mapToQueryResult(dto: GetUsersTopRankResponse): GetTopRankQueryResult {
    return {
      users: dto.users.map((user: UserRankDto): TopRankUser => {
        return {
          userId: user.userId,
          displayName: user.displayName,
          thumbnail: user.thumbnail,
          points: user.points,
          rank: user.rank,
          totalUsers: user.totalUsers
        };
      }),
      cached: dto.cached
    };
  }
}
